export const PREVIEW_STATUSES = [
  'draft',
  'published',
] as const
